/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AvatarChatActivityReassign_EmbedChatActivity = {
    readonly _id: string;
    readonly assignee: {
        readonly " $fragmentRefs": FragmentRefs<"AvatarNode_EmbedNode">;
    } | null;
    readonly groupAssignee: {
        readonly " $fragmentRefs": FragmentRefs<"AvatarNode_EmbedNode">;
    } | null;
    readonly " $refType": "AvatarChatActivityReassign_EmbedChatActivity";
};
export type AvatarChatActivityReassign_EmbedChatActivity$data = AvatarChatActivityReassign_EmbedChatActivity;
export type AvatarChatActivityReassign_EmbedChatActivity$key = {
    readonly " $data"?: AvatarChatActivityReassign_EmbedChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AvatarChatActivityReassign_EmbedChatActivity">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "AvatarNode_EmbedNode"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarChatActivityReassign_EmbedChatActivity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "groupAssignee",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
})();
(node as any).hash = 'b42ad88e7f9bc85445cfbd5e40da17ef';
export default node;
